"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _filesize = _interopRequireDefault(require("filesize"));

var _utils = require("./utils");

var _httpUtils = require("./http-utils");

var _uploadError = _interopRequireDefault(require("./upload-error"));

var _httpResult = _interopRequireDefault(require("./http-result"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Represents the results of an individual file upload. These results include information like
 * the amount of time the file took to upload, the number of parts in which the file was uploaded,
 * and any error information that may have occurred during the upload.
 */
var FileUploadResult = /*#__PURE__*/function (_HttpResult) {
  _inherits(FileUploadResult, _HttpResult);

  var _super = _createSuper(FileUploadResult);

  /**
   * Constructs a new instance of the result, which can be used to provide result values.
   *
   * @param {object} options Options as provided when the upload instance was instantiated.
   * @param {DirectBinaryUploadOptions} uploadOptions Options as provided when the upload was initiated.
   * @param {InitResponseFileInfo} initResponseFileInfo File information on which the results are based.
   */
  function FileUploadResult(options, uploadOptions, initResponseFileInfo) {
    var _this;

    _classCallCheck(this, FileUploadResult);

    _this = _super.call(this, options, uploadOptions);
    _this.initResponseFileInfo = initResponseFileInfo;
    _this.parts = [];
    _this.cancelled = false;
    return _this;
  }
  /**
   * Starts a timer that will be used to determine the total duration of the file upload.
   */


  _createClass(FileUploadResult, [{
    key: "startTimer",
    value: function startTimer() {
      this.start = new Date().getTime();
    }
    /**
     * Retrieves the timestamp when the file started to transfer.
     * @returns {number} A timestamp.
     */

  }, {
    key: "getStartTime",
    value: function getStartTime() {
      return this.start;
    }
    /**
     * Stops the timer and calculates the amount of time elapsed since startTimer() was called.
     */

  }, {
    key: "stopTimer",
    value: function stopTimer() {
      if (this.start) {
        this.totalTime = new Date().getTime() - this.start;
      }
    }
    /**
     * Retrieves the name of the file that was uploaded, as provided in the upload options.
     *
     * @returns {string} The name of the file.
     */

  }, {
    key: "getFileName",
    value: function getFileName() {
      return this.initResponseFileInfo.getFileName();
    }
    /**
     * Retrieves the size of the file (in bytes) that was uploaded, as provided in the upload options.
     *
     * @returns {number} File size in bytes.
     */

  }, {
    key: "getFileSize",
    value: function getFileSize() {
      return this.initResponseFileInfo.getFileSize();
    }
    /**
     * Adds an individual part upload result to the file's result. These will be used to compile additional statistics about the
     * upload.
     *
     * @param {PartUploadResult} partResult The new part result whose metrics will be incorporated in the file results.
     */

  }, {
    key: "addPartResult",
    value: function addPartResult(partResult) {
      this.parts.push(partResult);
    }
    /**
     * Retrieves the number of parts in which the file was uploaded.
     *
     * @returns {number} Number of file part uploads.
     */

  }, {
    key: "getPartCount",
    value: function getPartCount() {
      return this.parts.length;
    }
    /**
     * Retrieves the total amount of time, in milliseconds, that the file upload took. This is the amount of time
     * between when startTimer() and stopTimer() were called.
     *
     * @returns {number} A time span in milliseconds.
     */

  }, {
    key: "getTotalUploadTime",
    value: function getTotalUploadTime() {
      return this.totalTime || 0;
    }
    /**
     * Directly sets the total amount of time it took, in milliseconds, for
     * the file to upload.
     *
     * @param {number} elapsedTime Time span in milliseconds.
     */

  }, {
    key: "setTotalUploadTime",
    value: function setTotalUploadTime(elapsedTime) {
      this.totalTime = elapsedTime;
    }
    /**
     * Retrieves the transfer rate of the file, in bytes per second. Will return 0
     * if the file uploaded too quickly to get a meaningful rate.
     *
     * @returns {number} Bytes per second value.
     */

  }, {
    key: "getUploadRate",
    value: function getUploadRate() {
      return (0, _httpUtils.calculateRate)(this.getTotalPartUploadTime(), this.getFileSize());
    }
    /**
     * Gets the total amount of time, in milliseconds, it took for all parts (only) to upload. This
     * will exclude the init and complete time.
     *
     * @returns {number} Timespan in milliseconds.
     */

  }, {
    key: "getTotalPartUploadTime",
    value: function getTotalPartUploadTime() {
      return this.parts.reduce(function (a, b) {
        return a + b;
      }, 0);
    }
    /**
     * Retrieves the amount of time, in milliseconds, that it took the part that completed the fastest to transfer.
     *
     * @returns {number} A time span in milliseconds.
     */

  }, {
    key: "getFastestPartUploadTime",
    value: function getFastestPartUploadTime() {
      return Math.min.apply(Math, _toConsumableArray(this.parts.map(function (part) {
        return part.getUploadTime();
      })));
    }
    /**
     * Retrieves the amount of time, in milliseconds, that it took the part that completed the slowest to transfer.
     *
     * @returns {number} A time span in milliseconds.
     */

  }, {
    key: "getSlowestPartUploadTime",
    value: function getSlowestPartUploadTime() {
      return Math.max.apply(Math, _toConsumableArray(this.parts.map(function (part) {
        return part.getUploadTime();
      })));
    }
    /**
     * The average amount of time, in milliseconds, that it took for parts to transfer.
     *
     * @returns {number} A time span in milliseconds.
     */

  }, {
    key: "getAveragePartUploadTime",
    value: function getAveragePartUploadTime() {
      return (0, _utils.getAverage)(this.parts.map(function (part) {
        return part.getUploadTime();
      }));
    }
    /**
     * The amount of time, in milliseconds, that it took for the file's complete call to finish.
     *
     * @returns {number} A time span in milliseconds.
     */

  }, {
    key: "getTotalCompleteTime",
    value: function getTotalCompleteTime() {
      return this.completeTime || 0;
    }
    /**
     * Sets the amount of time, in milliseconds, that it took for the file's complete call to finish.
     *
     * @param {number} completeTime A time span in milliseconds.
     */

  }, {
    key: "setTotalCompleteTime",
    value: function setTotalCompleteTime(completeTime) {
      this.completeTime = completeTime;
    }
    /**
     * Retrieves a value indicating whether or not the file transferred successfully.
     *
     * @returns {boolean} TRUE if the transfer succeeded, false otherwise.
     */

  }, {
    key: "isSuccessful",
    value: function isSuccessful() {
      return !this.getErrors().length && !this.isCancelled();
    }
    /**
     * Retrieves any errors that may have occurred during the file transfer. There may be multiple errors
     * if multiple parts failed to transfer.
     *
     * @returns {Array} An array of UploadError instances representing errors that happend while transferring.
     */

  }, {
    key: "getErrors",
    value: function getErrors() {
      var errors = [];

      if (this.error) {
        errors.push(this.error);
      }

      this.parts.forEach(function (part) {
        if (!part.isSuccessful()) {
          errors.push(part.getError());
        }
      });
      return errors;
    }
    /**
     * Sets the error message that occurred when attempting to complete the upload for the file.
     *
     * @param {*} error Error object, which will be wrapped in an UploadError instance.
     */

  }, {
    key: "setCompleteError",
    value: function setCompleteError(error) {
      this.error = _uploadError.default.fromError(error, "unable to complete upload for file ".concat(this.getFileName()));
    }
    /**
     * Retrieves all the part results that make up the total file upload result.
     *
     * @returns {Array} List of PartUploadResult instances.
     */

  }, {
    key: "getPartUploadResults",
    value: function getPartUploadResults() {
      return this.parts;
    }
    /**
     * Retrieves a value indicating whether or not the file upload was cancelled.
     *
     * @returns {boolean} True if the file upload was cancelled, false otherwise.
     */

  }, {
    key: "isCancelled",
    value: function isCancelled() {
      return this.cancelled;
    }
    /**
     * Sets whether or not the file upload was cancelled.
     *
     * @param {boolean} cancelled Value indicating whether transfer was cancelled.
     */

  }, {
    key: "setIsCancelled",
    value: function setIsCancelled(cancelled) {
      this.cancelled = cancelled;
    }
    /**
     * Converts the result instance into a simple object containing all result data.
     *
     * @returns {object} Result data in a simple format.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var partSize = this.initResponseFileInfo.getFilePartSize();
      var message = '';
      this.getErrors().forEach(function (error) {
        if (message) {
          message += '\n';
        }

        message += error.getMessage();
      });

      var data = _objectSpread({
        fileName: this.initResponseFileInfo.getFileName(),
        targetPath: this.initResponseFileInfo.getTargetFilePath(),
        fileSize: this.initResponseFileInfo.getFileSize(),
        partSize: partSize,
        fileSizeStr: (0, _filesize.default)(this.initResponseFileInfo.getFileSize()),
        partSizeStr: (0, _filesize.default)(partSize),
        partNum: this.getPartCount(),
        putSpentFinal: this.getTotalUploadTime(),
        putSpentMin: this.getFastestPartUploadTime(),
        putSpentMax: this.getSlowestPartUploadTime(),
        putSpentAvg: this.getAveragePartUploadTime(),
        completeSpent: this.getTotalCompleteTime(),
        success: this.isSuccessful(),
        message: message,
        partDetails: this.parts.map(function (part) {
          return part.toJSON();
        })
      }, _get(_getPrototypeOf(FileUploadResult.prototype), "toJSON", this).call(this));

      if (this.isCancelled()) {
        data.cancelled = true;
      }

      var createVersion = this.initResponseFileInfo.shouldCreateNewVersion();
      var versionLabel = this.initResponseFileInfo.getVersionLabel();
      var versionComment = this.initResponseFileInfo.getVersionComment();
      var shouldReplace = this.initResponseFileInfo.shouldReplace();

      if (createVersion) {
        data.createVersion = createVersion;
      }

      if (versionLabel) {
        data.versionLabel = versionLabel;
      }

      if (versionComment) {
        data.versionComment = versionComment;
      }

      if (shouldReplace) {
        data.replace = shouldReplace;
      }

      return data;
    }
  }]);

  return FileUploadResult;
}(_httpResult.default);

exports.default = FileUploadResult;